import CheckIcon from '@mui/icons-material/CheckCircleRounded';
import { Box, Layout, Text } from '@src/shared/ui';
import React from 'react';
import { AlertInfo, NextStep, CountDown, FlightAccordion } from './components';
import { PurchaseDetails } from './components/purchase-details';
import { DescriptionTicket, TitleTicket } from './components/titles';
import { AlertTicket } from './components/alert-ticket';
import { RedirectModal } from './modals';
import { useTicketController } from './hooks';
import {
  formatBR,
  formatBRDate,
  getDownPaymentPlusInstallment,
} from '@src/shared/utils';
import { Snackbar } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Lottie from 'lottie-react';
import success from './animations/success.json';

export const TicketPage: React.FC = () => {
  const {
    modalRedict,
    openModelMoreDetails,
    onCountDownRedirect,
    loanSimulation,
    onCopy,
    onCopyBarCode,
    proposal,
    onDownloadTicket,
    closeToast,
    calculateSessionTTL,
  } = useTicketController();

  return (
    <>
      <Layout
        header={{
          step: true,
        }}
        beforeGrid={<AlertInfo />}
      >
        <Box
          className={`
          ${
            openModelMoreDetails &&
            `
              fixed
            `
          }
            z-0
            col-span-4
            sm:col-span-8
            md:col-span-6
            pb-[56px]
            sm:pb-20
            md:pb-0
          `}
        >
          <Lottie
            className={`
              mt-10
              sm:mt-12
              md:mt-14
              max-h-[120px]
              max-w-[274px]
            `}
            animationData={success}
            loop={false}
          />
          <TitleTicket />
          <Box
            className={`
              block
              md:hidden
              sm:col-span-8
              sm:row-start-3
            `}
          >
            <PurchaseDetails
              numberOfInstallments={getDownPaymentPlusInstallment(
                loanSimulation
              )}
              dueDate={formatBRDate(proposal.payments[0]!.dueDate)}
              downPayment={formatBR(loanSimulation.downPayment)}
              downloadTicket={onDownloadTicket}
              copyBarCode={onCopyBarCode}
              copyTicket={onCopy}
            />
            <AlertTicket className='flex md:hidden' />
          </Box>
          <DescriptionTicket />
          <NextStep icon='qrcode' className='mt-6 sm:mt-8'>
            Pague o boleto de entrada pelo app do banco de sua preferência.
            <strong className='font-semibold'> Dica</strong>: Pagar através do
            código PIX ou do QR Code pode acelerar o processo de compensação;
          </NextStep>
          <NextStep icon='ticket' className='mt-6 sm:mt-8'>
            O seu bilhete será emitido{' '}
            <strong className='font-semibold'>
              após recebermos a confirmação do pagamento
            </strong>{' '}
            da primeira parcela;
          </NextStep>
          <NextStep icon='mail' className='mt-6 sm:mt-8'>
            Enviaremos os próximos boletos para o seu e-mail.
          </NextStep>
          <FlightAccordion />
          <CountDown
            onComplete={onCountDownRedirect}
            calculateSessionTTL={calculateSessionTTL}
          />
        </Box>
        <Box
          className={`
          hidden
          sm:block
          sm:col-span-8
          md:col-start-8
          md:col-span-5
        `}
        >
          <PurchaseDetails
            className='hidden md:block'
            numberOfInstallments={getDownPaymentPlusInstallment(loanSimulation)}
            dueDate={formatBRDate(proposal.payments[0]!.dueDate)}
            downPayment={formatBR(loanSimulation.downPayment)}
            downloadTicket={onDownloadTicket}
            copyBarCode={onCopyBarCode}
            copyTicket={onCopy}
          />
          <AlertTicket className='hidden md:flex' />
        </Box>
      </Layout>
      {modalRedict.open && <RedirectModal kind={modalRedict.kind} />}
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={modalRedict.openToast}
        onClose={closeToast}
        autoHideDuration={1200}
        key={'top center'}
        sx={{
          padding: '0px',
          margin: '16px',
          minWidth: {
            sm: '468px',
          },
          maxWidth: {
            sm: '468px',
          },
          justifyContent: 'center',
          alignSelf: 'center',
        }}
      >
        <Box
          className={`
            flex
            items-center
            p-6
            md:mt-[64px]
            max-h-[72px]
            rounded-2xl
            shadow-md
            bg-[#E8F1ED]
            w-[100%]
            sm:max-w-[468px]
            justify-between
          `}
        >
          <Box className='flex items-center'>
            <CheckIcon
              color='success'
              sx={{
                fontSize: '24px',
              }}
            />
            <Text className='pl-3 text-base'>
              {modalRedict.kind === 'copy'
                ? 'Código Pix copiado!'
                : modalRedict.kind === 'copyBarCode'
                  ? 'Código de barras copiado!'
                  : ''}
            </Text>
          </Box>
          <IconButton onClick={closeToast} sx={{ padding: '0px', zIndex: 1 }}>
            <object type='image/svg+xml' data='close-alert-icon.svg'></object>
          </IconButton>
        </Box>
      </Snackbar>
    </>
  );
};
